import { Column } from "@gadgetinc/widgets";
import { useStyletron } from "baseui";
import { HeadingXLarge, ParagraphLarge } from "baseui/typography";
import type { ReactNode } from "react";
import React from "react";

export const AuthTitle = (props: { children: ReactNode; subTitle?: ReactNode; maxWidth?: string }) => {
  const [_, $theme] = useStyletron();
  return (
    <Column $as="header" $gap={$theme.sizing.scale300} $style={{ display: "flex", alignSelf: "stretch" }}>
      <HeadingXLarge $style={{ fontSize: "20px", fontWeight: 600, lineHeight: "30px", maxWidth: props.maxWidth }}>
        {props.children}
      </HeadingXLarge>
      {props.subTitle && (
        <ParagraphLarge $style={{ fontSize: "14px", fontWeight: 500, lineHeight: "20px", paddingBottom: "10px" }}>
          {props.subTitle}
        </ParagraphLarge>
      )}
    </Column>
  );
};
